import React from 'react';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionExpiredOverlay({ reason }) {
  const navigate = useNavigate();
  const isTrialExpired = reason === 'trial';

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="subscription-expired-overlay">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-amber-500 to-orange-500 flex items-center justify-center mx-auto mb-5">
          <AlertTriangle className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          {isTrialExpired ? 'Your Free Trial Has Expired' : 'Subscription Expired'}
        </h2>
        <p className="text-gray-500 mb-6">
          {isTrialExpired 
            ? 'Your 7-day free trial has ended. Subscribe to continue managing your dealership.'
            : 'Your subscription has expired. Renew to regain access to all features.'
          }
        </p>
        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/pricing')} 
            className="w-full h-12 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-xl font-semibold"
            data-testid="subscribe-now-btn"
          >
            <CreditCard className="w-4 h-4 mr-2" /> View Plans & Subscribe
          </Button>
          <p className="text-xs text-gray-400">Starting at $22.99/mo. Cancel anytime.</p>
        </div>
      </div>
    </div>
  );
}
